import LoadingIndicator from "../components/loading-indicator";

export default function Loading() {
  return (
    <div className="grid min-h-0 flex-1 place-items-center">
      <LoadingIndicator />
    </div>
  );
}
